'use client';

import AccountChip from '@/components/AccountChip';
import { useUserContext } from '@/context/user';
import { REVOKE_CUSTOMER_TOKEN } from '@/typed-graphql/mutation';
import { useMutation } from '@apollo/client';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useRef, useState } from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

const AccountTrigger = () => {
  const [{ isSignedIn }, { signOut }] = useUserContext();
  const triggerRef = useRef<HTMLButtonElement | null>(null);
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const [revokeToken] = useMutation(REVOKE_CUSTOMER_TOKEN);

  const handleSignOut = async () => {
    setOpen(false);
    await signOut({
      revokeToken,
    });
    router.push('/sign-in');
  };

  const menu = [
    {
      name: 'My Account',
      url: '/my-account',
    },
    {
      name: 'Order History',
      url: '/order-history',
    },
    {
      name: 'My Showroom',
      url: '/my-showroom',
    },
  ].map(item => {
    return (
      <li key={item.name}>
        <Link
          className='block text-center text-base leading-5 lg_hover_text-80583F lg_hover_underline'
          href={item.url}
          onClick={() => {
            setOpen(false);
          }}
        >
          {item.name}
        </Link>
      </li>
    );
  });

  return (
    <>
      {isSignedIn ? (
        <TooltipProvider delayDuration={100}>
          <Tooltip
            open={open}
            onOpenChange={setOpen}
          >
            <TooltipTrigger
              asChild
              onClick={e => {
                e.preventDefault();
              }}
              onPointerDown={event => event.preventDefault()}
              ref={triggerRef}
            >
              <button
                aria-label='Toggle My Account Menu'
                type='button'
              >
                <AccountChip />
              </button>
            </TooltipTrigger>
            <TooltipContent
              onPointerDownOutside={e => {
                if (triggerRef.current?.contains(e.target as Element)) {
                  e.preventDefault();
                }
              }}
              className='bg-white'
            >
              <ul className='flex w-[160px] flex-col gap-y-4 p-6'>
                {menu}
                <li>
                  <button
                    onClick={handleSignOut}
                    type='button'
                    className='block w-full text-center text-base leading-5 lg_hover_text-80583F lg_hover_underline'
                  >
                    Sign Out
                  </button>
                </li>
              </ul>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : (
        <Link
          href='/sign-in'
          aria-label='sign in'
          className='relative hidden flex-none items-center lg_flex '
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            width='25'
            height='24'
            fill='none'
            viewBox='0 0 25 24'
            className='h-auto lg_w-5'
          >
            <path
              className='fill-#403732 lg_group-hover_fill-80583F'
              d='M16.068 13.72c2.14-1.24 3.59-3.55 3.59-6.2 0-3.95-3.2-7.16-7.16-7.16a7.166 7.166 0 00-7.15 7.17c0 2.65 1.45 4.96 3.59 6.2a11.679 11.679 0 00-7.97 9.08c-.07.41.2.81.61.88.41.07.81-.2.88-.61a10.2 10.2 0 019.99-8.4h.12c4.92.03 9.11 3.55 9.99 8.4.07.37.39.62.75.62.04 0 .09 0 .14-.01.41-.08.69-.47.61-.88-.8-4.37-3.94-7.8-7.99-9.09zm-9.2-6.19c0-3.11 2.53-5.64 5.64-5.64s5.64 2.53 5.64 5.64c0 3.09-2.49 5.6-5.57 5.63h-.14c-3.08-.04-5.57-2.55-5.57-5.63z'
            />
            <path
              fill='#000'
              fillOpacity='0.2'
              d='M16.068 13.72c2.14-1.24 3.59-3.55 3.59-6.2 0-3.95-3.2-7.16-7.16-7.16a7.166 7.166 0 00-7.15 7.17c0 2.65 1.45 4.96 3.59 6.2a11.679 11.679 0 00-7.97 9.08c-.07.41.2.81.61.88.41.07.81-.2.88-.61a10.2 10.2 0 019.99-8.4h.12c4.92.03 9.11 3.55 9.99 8.4.07.37.39.62.75.62.04 0 .09 0 .14-.01.41-.08.69-.47.61-.88-.8-4.37-3.94-7.8-7.99-9.09zm-9.2-6.19c0-3.11 2.53-5.64 5.64-5.64s5.64 2.53 5.64 5.64c0 3.09-2.49 5.6-5.57 5.63h-.14c-3.08-.04-5.57-2.55-5.57-5.63z'
            />
          </svg>
        </Link>
      )}
    </>
  );
};

export default AccountTrigger;
